import { render, staticRenderFns } from "./AdminMaterialCategories.vue?vue&type=template&id=249084d6&scoped=true&lang=pug&"
import script from "./AdminMaterialCategories.vue?vue&type=script&lang=js&"
export * from "./AdminMaterialCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249084d6",
  null
  
)

export default component.exports